import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToastModule } from "primeng/toast";

import { NotifyService } from "./notify.service";
import { AlertComponent } from "./alert/alert.component";
import { ConfirmComponent } from "./confirm/confirm.component";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { SharedModule } from "app/shared/shared.module";
import { FormsModule } from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    SharedModule,
    FormsModule,
    AlertComponent,
    ConfirmComponent,
  ],
  providers: [NotifyService],
})
export class NotifyModule {}
